import React from 'react';
import { Paper } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => {
    return {
        barWrapper: {
            position: 'sticky',
            bottom: '-100px',
            display: 'flex',
            flexDirection: 'row-reverse',
            padding: theme.spacing(1),
            zIndex: 2
        }
    }
}

const AmazStickyBar = ({classes, children}) => {
    return (
        <Paper classes={{root: classes.barWrapper}}>
            { children }
        </Paper>
    );
}

export default withStyles(styles)(AmazStickyBar);
